import { Box, Grid, Stack, Text } from '@stitch-fix/mode-react';
import styles from './style.module.scss';

export type FullWidthContentProps = {
  title: string;
  description: string;
  list: {
    title: string;
    description: string;
  }[];
};

export const FullWidthContent = ({
  title,
  description,
  list,
}: FullWidthContentProps) => (
  <Box
    as="section"
    p="2rem 1.5rem"
    variant="info-light"
    style={{ textAlign: 'center' }}
  >
    <Box maxWidth="540px" m="0 auto">
      <Text setting="title-medium" as="h2" spacingBottom>
        {title}
      </Text>
      <Box pb={0.5}>
        <Text
          setting="body-small"
          dangerouslySetInnerHTML={{ __html: description }}
        />
      </Box>
      <Grid columns={{ sm: 1, md: 2 }} spacing="none" mb={0}>
        {list.map(item => (
          <Box maxWidth="200px" className={styles.item} key={item.title}>
            <Stack as="ul" spacing={0}>
              <Text setting="title-xsmall" as="h3">
                {item.title}
              </Text>
              <Text setting="body-small" as="p">
                {item.description}
              </Text>
            </Stack>
          </Box>
        ))}
      </Grid>
    </Box>
  </Box>
);
